import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { performanceActions } from '../actions';

const {
  loadTableConfigPerformance,
  enginePerformance,
  getChatUserPerformance,
  videoPerformance,
  setGameLoaded,
} = performanceActions;

type PerformanceEntry = {
  requestTimestamp: number | null;
  responseTimestamp: number | null;
}

export type Performance = {
  loadTableConfig: PerformanceEntry;
  engineRequest: PerformanceEntry;
  getChatUserRequest: PerformanceEntry;
  getVideoRequest: PerformanceEntry;
  gameLoaded: boolean;
  loadTime: number | null;
}

const initialState : Performance = {
  loadTableConfig: {
    requestTimestamp: null,
    responseTimestamp: null,
  },
  engineRequest: {
    requestTimestamp: null,
    responseTimestamp: null,
  },
  getChatUserRequest: {
    requestTimestamp: null,
    responseTimestamp: null,
  },
  getVideoRequest: {
    requestTimestamp: null,
    responseTimestamp: null,
  },
  gameLoaded: false,
  loadTime: null,
};

const performanceSlice = createSlice({
  name: 'performance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setGameLoaded, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      gameLoaded: true,
      loadTime: payload,
    }));
    builder.addCase(loadTableConfigPerformance.setRequestTimestamp, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      loadTableConfig: { ...state.loadTableConfig, requestTimestamp: payload },
    }));
    builder.addCase(loadTableConfigPerformance.setResponseTimestamp, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      loadTableConfig: { ...state.loadTableConfig, responseTimestamp: payload },
    }));
    builder.addCase(enginePerformance.setRequestTimestamp, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      engineRequest: { ...state.engineRequest, requestTimestamp: payload },
    }));
    builder.addCase(enginePerformance.setResponseTimestamp, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      engineRequest: { ...state.engineRequest, responseTimestamp: payload },
    }));
    builder.addCase(getChatUserPerformance.setRequestTimestamp, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      getChatUserRequest: { ...state.getChatUserRequest, requestTimestamp: payload },
    }));
    builder.addCase(getChatUserPerformance.setResponseTimestamp, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      getChatUserRequest: { ...state.getChatUserRequest, responseTimestamp: payload },
    }));
    builder.addCase(videoPerformance.setRequestTimestamp, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      getVideoRequest: { ...state.getVideoRequest, requestTimestamp: payload },
    }));
    builder.addCase(videoPerformance.setResponseTimestamp, (state, { payload }: PayloadAction<number>) => ({
      ...state,
      getVideoRequest: { ...state.getVideoRequest, responseTimestamp: payload },
    }));
  },
});

export const performanceActionsFromSlice = performanceSlice.actions;
export default performanceSlice.reducer;
